import React, { FC } from 'react';
import ReactModal from 'react-modal';
import { withTheme, ThemeInterface, styled } from '~/styles';
import { Header } from './Header';
import { Body } from './Body';
import { Footer } from './Footer';
import * as sc from './styles';
import { ModalStatus } from './types';
import { SvgClose } from '~/images/icons/Close';

interface Props {
  isOpen: boolean;
  status?: ModalStatus;
  onClose?: () => void;
  className?: string;
  isCloseable?: boolean;
  maxWidth?: number | string;
  isCentered?: boolean;
  theme: ThemeInterface;
}

export const ModalBase: FC<Props> = ({
  children,
  className,
  isOpen,
  isCloseable,
  isCentered,
  onClose,
  theme,
  status,
}) => {
  let overlayRef: HTMLDivElement | null = null;
  const handleCloseRequest = () => {
    if (!isCloseable) {
      return;
    }

    if (onClose) {
      onClose();
    }
  };

  // As modal is focused on open, we scroll it up to make sure we're at the top
  const handleAfterOpen = () => {
    if (overlayRef) {
      overlayRef.scroll(0, 0);
    }
  };

  return (
    <ReactModal
      isOpen={isOpen}
      appElement={document.getElementById('root') || undefined}
      contentLabel="Modal"
      closeTimeoutMS={theme.transitions.modal.ms}
      className={{
        base: 'pui-modal',
        afterOpen: 'pui-modal--after-open',
        beforeClose: 'pui-modal--before-close',
      }}
      overlayClassName={{
        base: `pui-modal__overlay ${className}`,
        afterOpen: 'pui-modal__overlay--after-open',
        beforeClose: 'pui-modal__overlay--before-close',
      }}
      onAfterOpen={handleAfterOpen}
      onRequestClose={handleCloseRequest}
      overlayRef={node => (overlayRef = node)}
    >
      {!!status && <sc.StatusBar status={status} />}
      {isCloseable && (
        <sc.CloseButton
          Asset={SvgClose}
          onClick={handleCloseRequest}
          height={44}
          width={44}
          color="gray.2"
          scale={0.62}
        />
      )}
      <sc.Inner isCentered={isCentered}>{children}</sc.Inner>
    </ReactModal>
  );
};

ModalBase.defaultProps = {
  isOpen: false,
  isCloseable: true,
  isCentered: true,
};

const EnhancedModal = styled(withTheme(ModalBase))`
  ${sc.modalStyle};
`;

export const Modal = Object.assign(EnhancedModal, {
  defaultProps: ModalBase.defaultProps,
  Header,
  Body,
  Footer,
});
try {
    // @ts-ignore
    ModalBase.displayName = "ModalBase";
    // @ts-ignore
    ModalBase.__docgenInfo = { "description": "", "displayName": "ModalBase", "props": { "isOpen": { "defaultValue": { value: "false" }, "description": "", "name": "isOpen", "required": true, "type": { "name": "boolean" } }, "status": { "defaultValue": null, "description": "", "name": "status", "required": false, "type": { "name": "ModalStatus" } }, "onClose": { "defaultValue": null, "description": "", "name": "onClose", "required": false, "type": { "name": "() => void" } }, "className": { "defaultValue": null, "description": "", "name": "className", "required": false, "type": { "name": "string" } }, "isCloseable": { "defaultValue": { value: "true" }, "description": "", "name": "isCloseable", "required": false, "type": { "name": "boolean" } }, "maxWidth": { "defaultValue": null, "description": "", "name": "maxWidth", "required": false, "type": { "name": "string | number" } }, "isCentered": { "defaultValue": { value: "true" }, "description": "", "name": "isCentered", "required": false, "type": { "name": "boolean" } }, "theme": { "defaultValue": null, "description": "", "name": "theme", "required": true, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Modal/Modal.tsx#ModalBase"] = { docgenInfo: ModalBase.__docgenInfo, name: "ModalBase", path: "src/components/Modal/Modal.tsx#ModalBase" };
}
catch (__react_docgen_typescript_loader_error) { }